'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DirectionalIcon = require('./DirectionalIcon');

var _DirectionalIcon2 = _interopRequireDefault(_DirectionalIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _DirectionalIcon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px', width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('polygon', { fill: fill, points: '1.3,6.7 2.7,8.1 7,3.8 7,16 9,16 9,3.8 13.3,8.1 14.7,6.7 8,0 ' })
      )
    )
  );
};

Arrow.propTypes = _extends({}, _DirectionalIcon2.default.propTypes);

Arrow.defaultProps = _extends({}, _DirectionalIcon2.default.defaultProps);

exports.default = Arrow;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0Fycm93LmpzIl0sIm5hbWVzIjpbIkFycm93IiwiZmlsbCIsInByb3BzIiwiZGlzcGxheSIsInByb3BUeXBlcyIsImRlZmF1bHRQcm9wcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7Ozs7OztBQUVBLElBQU1BLFFBQVEsU0FBUkEsS0FBUSxPQUF3QjtBQUFBLE1BQXJCQyxJQUFxQixRQUFyQkEsSUFBcUI7QUFBQSxNQUFaQyxLQUFZOztBQUNwQyxTQUNFO0FBQUE7QUFBcUJBLFNBQXJCO0FBQ0U7QUFBQTtBQUFBLFFBQUssT0FBTyxFQUFFQyxTQUFTLE9BQVgsRUFBWixFQUFrQyxPQUFNLDRCQUF4QyxFQUFxRSxZQUFXLDhCQUFoRixFQUErRyxHQUFFLEtBQWpILEVBQXVILEdBQUUsS0FBekgsRUFBK0gsT0FBTSxNQUFySSxFQUE0SSxRQUFPLE1BQW5KLEVBQTBKLFNBQVEsV0FBbEs7QUFDRTtBQUFBO0FBQUE7QUFDRSxtREFBUyxNQUFNRixJQUFmLEVBQXFCLFFBQU8sOERBQTVCO0FBREY7QUFERjtBQURGLEdBREY7QUFTRCxDQVZEOztBQVlBRCxNQUFNSSxTQUFOLGdCQUNLLDBCQUFnQkEsU0FEckI7O0FBSUFKLE1BQU1LLFlBQU4sZ0JBQ0ssMEJBQWdCQSxZQURyQjs7a0JBSWVMLEsiLCJmaWxlIjoiQXJyb3cuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgRGlyZWN0aW9uYWxJY29uIGZyb20gJy4vRGlyZWN0aW9uYWxJY29uJ1xuXG5jb25zdCBBcnJvdyA9ICh7IGZpbGwsIC4uLnByb3BzIH0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8RGlyZWN0aW9uYWxJY29uIHsuLi5wcm9wc30+XG4gICAgICA8c3ZnIHN0eWxlPXt7IGRpc3BsYXk6ICdibG9jaycgfX0geG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJyB4bWxuc1hsaW5rPSdodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rJyB4PScwcHgnIHk9JzBweCcgd2lkdGg9JzEwMCUnIGhlaWdodD0nMTAwJScgdmlld0JveD0nMCAwIDE2IDE2Jz5cbiAgICAgICAgPGc+XG4gICAgICAgICAgPHBvbHlnb24gZmlsbD17ZmlsbH0gcG9pbnRzPScxLjMsNi43IDIuNyw4LjEgNywzLjggNywxNiA5LDE2IDksMy44IDEzLjMsOC4xIDE0LjcsNi43IDgsMCAnIC8+XG4gICAgICAgIDwvZz5cbiAgICAgIDwvc3ZnPlxuICAgIDwvRGlyZWN0aW9uYWxJY29uPlxuICApXG59XG5cbkFycm93LnByb3BUeXBlcyA9IHtcbiAgLi4uRGlyZWN0aW9uYWxJY29uLnByb3BUeXBlc1xufVxuXG5BcnJvdy5kZWZhdWx0UHJvcHMgPSB7XG4gIC4uLkRpcmVjdGlvbmFsSWNvbi5kZWZhdWx0UHJvcHNcbn1cblxuZXhwb3J0IGRlZmF1bHQgQXJyb3dcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Arrow.js
// module id = 1114
// module chunks = 0